export default __webpack_public_path__ + "static/countryBackground-ae47b44d2197463342ee0285d1c1e53a.png";